// extracted by mini-css-extract-plugin
export default {"root__content":"style-module__root__content___IYY5B","root__group":"style-module__root__group___b3kj0","root__group_item":"style-module__root__group_item___B6jDR","root__text":"style-module__root__text___pJ0wS","root__icon":"style-module__root__icon___zeJl8"};
    if(module.hot) {
      // 1729151124050
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  